export default __webpack_public_path__ + "static/media/hignKneeFour.ff4a6205.png";